// import { Component, OnInit } from '@angular/core';
// import {
//   UntypedFormGroup,
//   UntypedFormControl,
//   UntypedFormBuilder,
//   Validators,
//   FormsModule,
//   ReactiveFormsModule,
// } from '@angular/forms';
// import { ApilistService } from 'src/app/services/apilist.service';
// import { CommonService } from 'src/app/services/common.service';
// import { GlobalService } from 'src/app/services/global.service';
// import { NgxSpinnerService } from 'ngx-spinner';
// import { CommonModule } from '@angular/common';

// @Component({
//   selector: 'app-add-country',
//   standalone: true,
//   imports: [
//     CommonModule, // ✅ for *ngIf, *ngFor, ngStyle
//     FormsModule, // ✅ for [(ngModel)]
//     ReactiveFormsModule, // ✅ for reactive forms
//   ],
//   templateUrl: './add-country.component.html',
//   styleUrls: ['./add-country.component.scss'],
// })
// export class AddCountryComponent implements OnInit {
//   display: any = 'none';
//   displayDelete: any = 'none';

//   countryForm: UntypedFormGroup;

//   showAdd = false;
//   showEdit = false;
//   id: any;

//   degreeType: any;
//   showErr = false;
//   deleteErr: any;
//   country: any;

//   error_messages = {
//     countryName: [{ type: 'required', message: 'Please enter country name' }],
//   };
//   countryVal: any;
//   adminName: any;
//   adminImage: any;
//   allCountry: any;
//   allData: any;

//   showData = false;
//   showNodata = false;

//   searchval: any;

//   constructor(
//     public utils: ApilistService,
//     public commonservice: CommonService,
//     public globalService: GlobalService,
//     public formBuilder: UntypedFormBuilder,
//     private spinner: NgxSpinnerService
//   ) {
//     this.countryForm = this.formBuilder.group({
//       countryName: new UntypedFormControl(
//         '',
//         Validators.compose([Validators.required])
//       ),
//     });

//     let admin = JSON.parse(localStorage.getItem('adminDetails'));
//     let adminData = JSON.parse(admin);

//     this.adminName = adminData[0].name;
//     this.adminImage = adminData[0].image;
//     if (this.adminImage == null || this.adminImage == undefined) {
//       this.adminImage = 'assets/tenant-avatar.jpg';
//     }
//   }

//   ngOnInit(): void {
//     this.spinner.show();
//     this.countryForm.reset();
//     // GET COUNTRY \\
//     const servicePathCountry = this.utils.getApiConfigs('country');
//     // console.log("servicePathCollege", servicePathCountry);
//     this.commonservice
//       .invokeService(
//         servicePathCountry[1].method,
//         servicePathCountry[1].path,
//         ''
//       )
//       .then((resp: any) => {
//         this.spinner.hide();
//         if (resp.status_code == '200') {
//           this.spinner.hide();
//           this.countryVal = resp.data;
//           // console.log("Country", this.country);

//           if (this.countryVal == '') {
//             this.showNodata = true;
//             this.showData = false;
//           } else {
//             this.showData = true;
//             this.showNodata = false;
//           }
//         }
//         this.allCountry = this.countryVal;
//       });
//   }

//   onChangeEvent(event) {
//     // console.log("event", event);

//     var val = event.target.value;
//     // console.log("val", val);

//     this.allData = this.countryVal;

//     // console.log("All Data", this.allData);

//     if (val) {
//       this.allCountry = this.allData.filter((item) =>
//         item.country.toLowerCase().includes(val.toLowerCase())
//       );
//     }

//     // console.log("Courses Data", this.allCountry);
//     if (this.allCountry == '') {
//       this.globalService.showError('No data found');
//     }
//   }

//   reset() {
//     this.ngOnInit();
//     this.searchval = '';
//   }

//   onCloseHandled() {
//     this.display = 'none';
//     this.displayDelete = 'none';
//     this.ngOnInit();
//   }

//   openAdd() {
//     this.countryForm.reset();
//     this.display = 'block';
//     this.showAdd = true;
//     this.showEdit = false;
//   }

//   editCountry(data) {
//     this.display = 'block';
//     this.showAdd = false;
//     this.showEdit = true;

//     this.id = data.id;
//     this.country = data.country;
//   }

//   addCountry() {
//     this.spinner.show();
//     let payload = {
//       country: this.country,
//     };
//     // console.log("payload", payload);
//     const servicePath = this.utils.getApiConfigs('country');
//     this.commonservice
//       .invokeService(servicePath[0].method, servicePath[0].path, payload)
//       .then((resp: any) => {
//         // console.log("resp", resp);
//         this.spinner.hide();
//         if (resp.status_code == '200') {
//           // console.log(resp);
//           this.spinner.hide();
//           this.globalService.showSuccess('Country added successfully');
//           this.display = 'none';
//           this.ngOnInit();
//           this.countryForm.reset();
//         } else if (resp.status_code == '400') {
//           this.spinner.hide();
//           // console.log("data", resp.data);
//           this.globalService.showError(resp.data);
//         }
//       });
//   }

//   updateCountry() {
//     this.spinner.show();
//     let payload = {
//       country: this.country,
//       id: this.id,
//     };
//     // console.log("payload", payload);
//     const servicePath = this.utils.getApiConfigs('country');
//     this.commonservice
//       .invokeService(servicePath[0].method, servicePath[0].path, payload)
//       .then((resp: any) => {
//         // console.log("resp", resp);
//         this.spinner.hide();
//         if (resp.status_code == '200') {
//           // console.log(resp);
//           this.spinner.hide();
//           this.globalService.showSuccess('Country updated successfully');
//           this.display = 'none';
//           this.ngOnInit();
//         } else if (resp.status_code == '400') {
//           this.spinner.hide();
//           // console.log("data", resp.data);
//           this.globalService.showError(resp.data);
//         }
//       });
//   }

//   delete() {}

//   deleteCountry(data) {}
// }
import { Component, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';
import { GlobalService } from 'src/app/services/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-add-country',
  standalone: true,
  imports: [
    CommonModule, // ✅ for *ngIf, *ngFor, ngStyle
    FormsModule, // ✅ for [(ngModel)]
    ReactiveFormsModule, // ✅ for reactive forms
  ],
  templateUrl: './add-country.component.html',
  styleUrls: ['./add-country.component.scss'],
})
export class AddCountryComponent implements OnInit {
  display: any = 'none';
  displayDelete: any = 'none';

  countryForm: UntypedFormGroup;

  showAdd = false;
  showEdit = false;
  id: any;

  degreeType: any;
  showErr = false;
  deleteErr: any = '';
  country: any;

  error_messages = {
    countryName: [{ type: 'required', message: 'Please enter country name' }],
  };
  countryVal: any;
  adminName: any;
  adminImage: any;
  allCountry: any;
  allData: any;

  showData = false;
  showNodata = false;

  searchval: any;

  // new properties for delete flow
  selectedDeleteId: number | null = null;

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.countryForm = this.formBuilder.group({
      countryName: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    // try to read admin details safely
    try {
      const adminRaw = localStorage.getItem('adminDetails');
      if (adminRaw) {
        const adminParsed = JSON.parse(adminRaw);
        // previous code assumed nested JSON string; handle both cases
        let adminData = adminParsed;
        if (typeof adminParsed === 'string') {
          adminData = JSON.parse(adminParsed);
        }

        if (Array.isArray(adminData) && adminData.length) {
          this.adminName = adminData[0].name;
          this.adminImage = adminData[0].image;
        }
      }
    } catch (e) {
      console.warn('Unable to parse admin details from localStorage', e);
    }

    if (!this.adminImage) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
  }

  ngOnInit(): void {
    this.spinner.show();
    this.countryForm.reset();

    // GET COUNTRY - using utils config
    const servicePathCountry = this.utils.getApiConfigs('country');

    // If utils returns an array where index 1 is GET, use that; otherwise try fallback
    const getConfig =
      servicePathCountry && servicePathCountry[1]
        ? servicePathCountry[1]
        : null;

    if (getConfig) {
      this.commonservice
        .invokeService(getConfig.method, getConfig.path, '')
        .then((resp: any) => {
          this.spinner.hide();
          if (resp && (resp.status_code == '200' || resp.status_code === 200)) {
            this.countryVal = resp.data;

            if (!this.countryVal || this.countryVal.length === 0) {
              this.showNodata = true;
              this.showData = false;
            } else {
              this.showData = true;
              this.showNodata = false;
            }

            this.allCountry = this.countryVal;
          } else {
            // handle non-200 gracefully
            this.spinner.hide();
            this.allCountry = [];
            this.showData = false;
            this.showNodata = true;
          }
        })
        .catch((err) => {
          this.spinner.hide();
          console.error('Error fetching countries', err);
          this.allCountry = [];
          this.showData = false;
          this.showNodata = true;
        });
    } else {
      // fallback: try calling the endpoint directly (if you prefer to use hardcoded path, change here)
      this.spinner.hide();
      this.allCountry = [];
      this.showData = false;
      this.showNodata = true;
    }
  }

  onChangeEvent(event) {
    const val = event.target.value;
    this.allData = this.countryVal || [];

    if (val) {
      this.allCountry = this.allData.filter(
        (item) =>
          item.country && item.country.toLowerCase().includes(val.toLowerCase())
      );
    } else {
      this.allCountry = this.allData;
    }

    if (!this.allCountry || this.allCountry.length === 0) {
      this.globalService.showError('No data found');
    }
  }

  reset() {
    this.searchval = '';
    this.ngOnInit();
  }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
    this.selectedDeleteId = null;
    this.showErr = false;
    this.deleteErr = '';
    this.ngOnInit();
  }

  openAdd() {
    this.countryForm.reset();
    this.display = 'block';
    this.showAdd = true;
    this.showEdit = false;
  }

  editCountry(data) {
    this.display = 'block';
    this.showAdd = false;
    this.showEdit = true;

    this.id = data.id;
    this.country = data.country;

    // prefill form control if you want
    if (this.countryForm && this.countryForm.get('countryName')) {
      this.countryForm.get('countryName').setValue(this.country);
    }
  }

  addCountry() {
    this.spinner.show();
    const payload = {
      country: this.country,
    };

    const servicePath = this.utils.getApiConfigs('country');
    const postConfig = servicePath && servicePath[0] ? servicePath[0] : null;

    if (postConfig) {
      this.commonservice
        .invokeService(postConfig.method, postConfig.path, payload)
        .then((resp: any) => {
          this.spinner.hide();
          if (resp && (resp.status_code == '200' || resp.status_code === 200)) {
            this.globalService.showSuccess('Country added successfully');
            this.display = 'none';
            this.ngOnInit();
            this.countryForm.reset();
          } else if (resp && resp.status_code == '400') {
            this.globalService.showError(resp.data);
          } else {
            this.globalService.showError('Failed to add country');
          }
        })
        .catch((err) => {
          this.spinner.hide();
          console.error('addCountry error', err);
          this.globalService.showError('Failed to add country');
        });
    } else {
      // fallback: try POST to standard path
      this.spinner.hide();
      this.globalService.showError(
        'Configuration for adding country not found'
      );
    }
  }

  updateCountry() {
    this.spinner.show();
    const payload = {
      country: this.country,
      id: this.id,
    };

    const servicePath = this.utils.getApiConfigs('country');
    const postConfig = servicePath && servicePath[0] ? servicePath[0] : null;

    if (postConfig) {
      this.commonservice
        .invokeService(postConfig.method, postConfig.path, payload)
        .then((resp: any) => {
          this.spinner.hide();
          if (resp && (resp.status_code == '200' || resp.status_code === 200)) {
            this.globalService.showSuccess('Country updated successfully');
            this.display = 'none';
            this.ngOnInit();
          } else if (resp && resp.status_code == '400') {
            this.globalService.showError(resp.data);
          } else {
            this.globalService.showError('Failed to update country');
          }
        })
        .catch((err) => {
          this.spinner.hide();
          console.error('updateCountry error', err);
          this.globalService.showError('Failed to update country');
        });
    } else {
      this.spinner.hide();
      this.globalService.showError(
        'Configuration for updating country not found'
      );
    }
  }

  // open delete modal for a specific country
  confirmDelete(country: any) {
    this.selectedDeleteId =
      country.id ?? country.country_id ?? country.ID ?? null;
    if (!this.selectedDeleteId) {
      this.showErr = true;
      this.deleteErr = 'Unable to identify the selected country.';
      return;
    }

    this.showErr = false;
    this.deleteErr = '';
    this.displayDelete = 'block';
  }

  // delete API call
  delete() {
    if (!this.selectedDeleteId) {
      this.showErr = true;
      this.deleteErr = 'No country selected to delete.';
      return;
    }

    this.spinner.show();

    // Use the explicit endpoint from your curl
    const removeUrl = '/removecountry';
    const payload = { id: this.selectedDeleteId };

    // try to use commonservice.invokeService - keep behaviour consistent with other calls
    this.commonservice
      .invokeService('POST', removeUrl, payload)
      .then((resp: any) => {
        this.spinner.hide();
        if (resp && (resp.status_code === '200' || resp.status_code === 200)) {
          this.globalService.showSuccess('Country deleted successfully');
          this.removeCountryFromList(this.selectedDeleteId);
          this.onCloseHandled();
        } else if (resp && resp.status_code === '400') {
          this.showErr = true;
          this.deleteErr = resp.data || 'Delete failed';
        } else {
          this.showErr = true;
          this.deleteErr =
            (resp && resp.data) ||
            'Failed to delete country. Please try again.';
        }
      })
      .catch((err) => {
        this.spinner.hide();
        this.showErr = true;
        this.deleteErr =
          (err && err.error && (err.error.message || err.error.msg)) ||
          err.message ||
          'Failed to delete. Please try again.';
        console.error('delete country error', err);
      });
  }

  // helper to remove country from local list
  private removeCountryFromList(id: number | null) {
    if (!this.allCountry || !id) return;

    this.allCountry = this.allCountry.filter((c: any) => {
      const cid = c.id ?? c.country_id ?? c.ID ?? null;
      return cid !== id;
    });

    if (!this.allCountry || this.allCountry.length === 0) {
      this.showData = false;
      this.showNodata = true;
    } else {
      this.showData = true;
      this.showNodata = false;
    }
  }

  // placeholder methods kept for compatibility
  deleteCountry(data) {
    // kept for backward compatibility if other parts of app call it
    this.confirmDelete(data);
  }
}
